/* eslint-disable import/prefer-default-export */

export const getUniqueImageFileName = (name: string): string => {
  const nameArr: string[] = name.replace(/[/\\?%*:|"<>]/g, '').split('.');
  const typeIndex = nameArr.length - 1;
  const type = nameArr[typeIndex];

  nameArr[typeIndex] = `_${new Date().getTime()}`;

  nameArr.push(`.${type}`);

  let newName = '';

  nameArr.forEach((item) => {
    newName += item;
  });

  return newName;
};

export const getShortName = (
  firstName: string,
  lastName?: string,
  returnFullName = false
): string => {
  let fullName = firstName;

  if (lastName) {
    if (returnFullName) {
      fullName += ` ${lastName}`;
    } else {
      fullName += ` ${lastName.substring(0, 1)}.`;
    }
  }

  return fullName;
};

export const getFormatedDurationByMinutes = ({
  minutes,
  format = 'type1',
}: {
  minutes: number;
  format?: 'type1' | 'type2';
}): string => {
  const minutesPositive = Math.abs(minutes);
  const hours =
    Math.floor(minutesPositive / 60) >= 1
      ? Math.floor(minutesPositive / 60)
      : 0;

  const mins = parseFloat((minutesPositive % 60).toFixed(2));

  let formatedDuration = '';
  let prefix = '';

  if (minutes < 0) {
    prefix = '-';
  }

  const _getHoursDurationText = (hoursNumber: number) => {
    let _text = 'hr';

    switch (format) {
      case 'type1':
        _text = 'hr';
        break;

      case 'type2':
        _text = `Hour${hoursNumber > 1 ? 's' : ''}`;
        break;

      default:
        _text = 'hr';
        break;
    }

    return _text;
  };

  const _getMinutesDurationText = (minutesNumber: number) => {
    let _text = 'min';

    switch (format) {
      case 'type1':
        _text = 'min';
        break;

      case 'type2':
        _text = `Minute${minutesNumber > 1 ? 's' : ''}`;
        break;

      default:
        _text = 'min';
        break;
    }

    return _text;
  };

  if (hours) {
    formatedDuration = `${hours} ${_getHoursDurationText(hours)}`;

    if (mins) {
      formatedDuration += ` ${mins} ${_getMinutesDurationText(mins)}`;
    }
  } else {
    formatedDuration += ` ${mins} ${_getMinutesDurationText(mins)}`;
  }

  if (prefix) {
    formatedDuration = `${prefix} ${formatedDuration}`;
  }

  return formatedDuration.trim();
};

export const getFormattedTime = (seconds = 0): string => {
  const val = Math.abs(seconds);

  const _hours = Math.floor(val / 3600)
    .toString()
    .padStart(2, '0');
  const _minutes = Math.floor((val % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const _seconds = Math.floor((val % 3600) % 60)
    .toString()
    .padStart(2, '0');

  return `${_hours}: ${_minutes}: ${_seconds}`;
};

export const msToMinutesSeconds = (ms: number): string => {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}m ${remainingSeconds}s`;
};

export const msToMinutesSecondsNew = (ms: number): string => {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes > 0 ? `${minutes}m` : ''} ${remainingSeconds}s`;
};

export const getOrdinalNumber = (n: number): string => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

// Helper function to extract error message from API response
export const extractErrorMessage = (res: any): string => {
  if (res?.error?.message) {
    try {
      const parsedError = JSON.parse(res.error.message);
      return (
        parsedError.data?.message || parsedError.message || 'An error occurred'
      );
    } catch (parseError) {
      // If parsing fails, use the raw message
      return res.error.message;
    }
  } else if (res?.message) {
    return res.message;
  }
  return 'Something went wrong';
};
